<form [formGroup]="form" *ngIf="model.flow_version && loadedFlow">
  <div class="flow-detail-container" fxLayout="column" fxFlex="100">
    <!-- FLOW TEST AB -  HEADER -->
    <div class="flow-header" *ngIf="model.is_ab">
      <mat-card appearance="outlined" class="flow">
        <mat-card-content fxLayoutGap="20px" fxLayoutGap.lt-md="0">
          <div class="test-menu" fxFlex="100">
            <div class="tab-list" fxFlex fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="50px"
              fxLayoutGap.lt-md="25px">
              <!-- FLOW TEST CONTROL HEADER -->

              <div class="tab" fxFlex="initial" fxLayout="row" fxLayoutAlign="start center" (click)="
                  changeTest(
                    model.selector_test?.selector_test_flows[0]?.flow_id,
                    model.selector_test?.selector_test_flows[0]?.version,
                    model.selector_test?.selector_test_flows[0]?.order
                  )
                " [ngClass]="{ active: model.ab == 'control' }">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div class="circle" fxLayoutAlign="center center">1</div>
                  <!-- TODO: Remover quando as infos de distribuição fore adicionadas -->
                  <!-- TODO: Adicionar informações da distribuição no primeiro valor do attr stroke-dasharray -->
                  <!--<div class="distribution" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="6px">
                    <div class="graph">
                      <svg viewBox="0 0 36 36" class="circular-chart">
                        <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                        <path class="circle" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                          attr.stroke-dasharray="{{model.flow.flows_descriptor[0].percent ? (model.flow.flows_descriptor[0].percent * 100  | number: '1.2-2':'en-us') + ', 100' : ' 0, 100 '}}" />
                      </svg>
                      <span class="percent fc-6">16%</span>
                    </div>
                  </div>-->
                </div>
                <div class="ml-3" fxLayout="column" fxLayoutGap="4px">
                  <div class="name">
                    {{
                    model.selector_test?.selector_test_flows[0]
                    ? model.selector_test?.selector_test_flows[0]?.name
                    : "Name"
                    }}
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="bullet" [ngClass]="{
                      alert: ( model.selector_test?.selector_test_flows[2]?.status == 0),
                      success: model.selector_test?.selector_test_flows[2]?.status == 1,
                      paused:  model.selector_test?.selector_test_flows[2]?.status == 2,
                      archived:  model.selector_test?.selector_test_flows[2]?.status== 3,
                    }"></div>
                    <div class="status fc-6" *ngIf="  model.selector_test?.selector_test_flows[2]?.status == 0">
                      {{ "flows.detail.status.draft" | translate }}
                    </div>
                    <div class="status fc-6" *ngIf="model.selector_test?.selector_test_flows[2]?.status == 1">
                      {{ "flows.detail.status.published" | translate }}
                    </div>
                    <div class="status fc-6" *ngIf="  model.selector_test?.selector_test_flows[2]?.status == 2">
                      {{ "flows.detail.status.paused" | translate }}
                    </div>
                    <div class="status fc-6" *ngIf="  model.selector_test?.selector_test_flows[2]?.status== 3">
                      {{ "flows.detail.status.archived" | translate }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- FLOW TEST A HEADER -->

              <div class="tab" fxFlex="initial" fxLayout="row" fxLayoutAlign="start center" (click)="
                  changeTest(
                    model.selector_test?.selector_test_flows[1].flow_id,
                    model.selector_test?.selector_test_flows[1].version,
                    model.selector_test?.selector_test_flows[1].order
                  )
                " [ngClass]="{ active: model.ab == 'A' }">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div class="circle" fxLayoutAlign="center center">A</div>
                </div>
                <div class="ml-3">
                  <div class="name">
                    {{ model.selector_test?.selector_test_flows[1].name }}
                  </div>
                </div>
              </div>

              <!-- FLOW TEST B HEADER -->

              <div class="tab" fxFlex="initial" fxLayout="row" fxLayoutAlign="start center" (click)="
                  changeTest(
                    model.selector_test?.selector_test_flows[2].flow_id,
                    model.selector_test?.selector_test_flows[2].version,
                    model.selector_test?.selector_test_flows[2].order
                  )
                " [ngClass]="{ active: model.ab == 'B' }">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div class="circle" fxLayoutAlign="center center">B</div>
                </div>
                <div class="ml-3">
                  <div class="name">
                    {{ model.selector_test?.selector_test_flows[2].name }}
                  </div>

                </div>

              </div>
            </div>

          </div>

          <div fxLayoutAlign="end center" fxLayoutGap="25px" fxLayoutGap.lt-lg="15px">
            <div class="tab tab-mobile" fxFlex fxFlexFill fxLayoutAlign="center center">
              <button class="open-ab-test desktop" mat-icon-button (click)="openCreateAb()"
                *ngIf="model.selector_test_flow?.status == 1 ||  model.is_ab">
                <mat-icon svgIcon="icon_experiment"></mat-icon>
              </button>
              <div fxHide fxShow.xs="true">{{ 'flows.detail.flow' | translate}}</div>
            </div>
            <div class="action-publish" fxShow fxHide.lt-md="true">
              <!-- <span class="stamp">beta</span> -->
              <button class="btn-publish h-medium" mat-flat-button color="primary" (click)="openValidate()"
                [disabled]="!permission.publish  || onlyViewer">
                <mat-icon aria-hidden="false" aria-label="validate" svgIcon="icon_validate"></mat-icon>
                <span>{{ "flows.detail.validate.label" | translate }}</span>
              </button>
            </div>
            <div class="action-menu" (click)="flowsList()">
              <mat-icon class="action-icon" aria-hidden="false" aria-label="close" svgIcon="icon_close"></mat-icon>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- FLOW NORMAL - HEADER  -->
    <div class="flow-header" *ngIf="!model.is_ab">
      <mat-card appearance="outlined" class="flow">
        <mat-card-content>
          <div fxFlex fxFlexFill fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.gt-sm="60px"
            fxLayoutGap.lt-md="0" fxLayoutAlign="start center" fxLayoutAlign.lt-md="space-between"
            *ngIf="model.selector_test">
            <div class="info" fxFlex="nogrow" fxLayoutGap="15px"
              *ngIf="model.selector_test?.selector_test_flows?.length > 0">
              <div>
                <!-- METRICS  -->

                <div fxFlex fxLayoutAlign="center center">
                  <div class="distribution" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="6px">
                    <div class="graph">
                      <svg viewBox="0 0 36 36" class="circular-chart">
                        <path class="circle-bg"
                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                        <path class="circle"
                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                          attr.stroke-dasharray="{{
                              model.selector_test_flow?.transaction_amount_percent > 0
                                ? (model.selector_test_flow?.transaction_amount_percent * 100
                                    | number : '1.2-2' : 'en-us') + ', 100'
                                : ' 0, 100 '
                            }}" />
                      </svg>
                      <span class="percent fc-6">{{
                        model.selector_test_flow?.transaction_amount_percent_string
                        }}</span>
                    </div>
                    <div class="value">
                      {{
                      model.selector_test_flow?.transaction_amount != null
                      ? formatter(model.selector_test_flow?.transaction_amount)
                      : " R$ 0"
                      }}
                    </div>
                  </div>
                </div>
              </div>

              <div fxFlex fxLayout="column" fxLayoutAlign="center start" *ngIf="model.selector_test">
                <div fxLayout="row wrap" fxLayoutAlign="start center">
                  <div class="name">
                    {{
                    model.selector_test_flow
                    ? model.selector_test_flow?.name
                    : "Name"
                    }}
                  </div>

                  <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="bullet" [ngClass]="{
                          alert:model.selector_test_flow?.status == 0 || model.selector_test_flow?.status == 4,
                          success:model.selector_test_flow?.status == 1,
                          paused: model.selector_test_flow?.status == 2,
                          archived: model.selector_test_flow?.status == 3
                        }"></div>
                    <div class="status h-medium"
                      *ngIf="model.selector_test_flow?.status == 0  || model.selector_test_flow?.status == 4">
                      {{ "flows.detail.status.draft" | translate }}
                    </div>
                    <div class="status h-medium" *ngIf="model.selector_test_flow?.status == 1">
                      {{ "flows.detail.status.published" | translate }}
                    </div>
                    <div class="status h-medium" *ngIf="model.selector_test_flow?.status == 2">
                      {{ "flows.detail.status.paused" | translate }}
                    </div>
                    <div class="status h-medium" *ngIf="model.selector_test_flow?.status == 3">
                      {{ "flows.detail.status.archived" | translate }}
                    </div>
                  </div>
                </div>

                <div class="description">
                  {{
                  model.selector_test_flow
                  ? model.selector_test_flow?.description
                  : "Name"
                  }}
                </div>
              </div>
            </div>

            <div *ngIf="metrics$ | async as metrics; else loading" class="list-itens" fxFlex="auto" fxLayout="row"
              fxLayoutGap.md="4px" fxLayoutAlign="none">
              <div class="container-itens" fxFlex fxLayout="row" *ngIf="!error">
                <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                  fxLayoutGap="5px">
                  <div class="text-secondary">
                    {{ "flows.income" | translate }}
                  </div>
                  <div class="text-primary">
                    {{
                    model.selector_test_flow
                    ?.net_amount_percent != null
                    ? (model.selector_test_flow
                    .net_amount_percent | percent : "1.2-2" : "en-us")
                    : " - "
                    }}
                  </div>

                  <div class="text-secondary">
                    {{
                    model.selector_test_flow?.net_amount != null
                    ? formatter(model.selector_test_flow?.net_amount)
                    : " - "
                    }}
                  </div>
                </div>
                <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                  fxLayoutGap="5px">
                  <div class="text-secondary">
                    {{ "flows.approveds" | translate }}
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start">
                    <div class="text-primary">
                      {{
                      model.selector_test_flow
                      ?.approved_amount_percent != null
                      ? (model.selector_test_flow
                      ?.approved_amount_percent
                      | percent : "1.2-2" : "en-us")
                      : " - "
                      }}
                    </div>
                  </div>
                  <div class="text-secondary">
                    {{
                    model.selector_test_flow?.approved_amount != null
                    ? formatter(model.selector_test_flow?.approved_amount)
                    : " - "
                    }}
                  </div>
                </div>
                <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                  fxLayoutGap="5px">
                  <div class="text-secondary">
                    {{ "flows.fees" | translate }}
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start">
                    <div class="text-primary">
                      {{
                      model.selector_test_flow
                      ?.fees_amount_percent != null
                      ? (model.selector_test_flow
                      .fees_amount_percent
                      | percent : "1.2-2" : "en-us")
                      : " - "
                      }}
                    </div>
                  </div>
                  <div class="text-secondary">
                    {{
                    model.selector_test_flow?.fee_amount != null
                    ? formatter(model.selector_test_flow?.fee_amount)
                    : " - "
                    }}
                  </div>
                </div>

                <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                  fxLayoutGap="5px">
                  <div class="text-secondary">
                    {{ "flows.fraudCosts" | translate }}
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start">
                    <div class="text-primary">
                      {{
                      model.selector_test_flow
                      ?.fraud_costs_amount_percent
                      ? (model.selector_test_flow
                      .fraud_costs_amount_percent
                      | percent : "1.2-2" : "en-us")
                      : " - "
                      }}
                    </div>
                  </div>
                  <div class="text-secondary">
                    {{
                    model.selector_test_flow?.fraud_amount
                    ? formatter(model.selector_test_flow?.fraud_amount)
                    : " - "
                    }}
                  </div>
                </div>
              </div>
              <div class="container-itens" fxFlex fxLayout="row" *ngIf="error">
                <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                  fxLayoutGap="5px">

                  <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <mat-icon class="fc-9">error</mat-icon>
                    <div class="text" fxFlex>
                      <span class="fs-12 fc-9"> Falha ao carregar os dados.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #loading>
              <div class="list-itens" fxFlex="none" fxFlex.gt-md="100%" fxLayout="row" fxLayoutGap.md="4px"
                fxLayoutAlign="none">
                <div class="container-itens" fxFlex fxLayout="row" *ngIf="!error">
                  <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                    fxLayoutGap="5px">
                    <div class="text-secondary">
                      {{ "flows.income" | translate }}
                    </div>
                    <div class="text-primary">
                      <svg width="45" height="15" viewBox="0 0 45 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="45" height="15" fill="#EEEEEE" />
                      </svg>
                    </div>
                    <div class="text-secondary">
                      <svg width="45" height="15" viewBox="0 0 45 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="45" height="15" fill="#EEEEEE" />
                      </svg>
                    </div>
                  </div>
                  <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                    fxLayoutGap="5px">
                    <div class="text-secondary">
                      {{ "flows.approveds" | translate }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start">
                      <div class="text-primary">
                        <svg width="45" height="15" viewBox="0 0 45 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="45" height="15" fill="#EEEEEE" />
                        </svg>
                      </div>
                    </div>
                    <div class="text-secondary">
                      <svg width="45" height="15" viewBox="0 0 45 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="45" height="15" fill="#EEEEEE" />
                      </svg>
                    </div>
                  </div>
                  <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                    fxLayoutGap="5px">
                    <div class="text-secondary">
                      {{ "flows.fees" | translate }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start">
                      <div class="text-primary">
                        <svg width="45" height="15" viewBox="0 0 45 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="45" height="15" fill="#EEEEEE" />
                        </svg>
                      </div>
                    </div>
                    <div class="text-secondary">
                      <svg width="45" height="15" viewBox="0 0 45 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="45" height="15" fill="#EEEEEE" />
                      </svg>
                    </div>
                  </div>
                  <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                    fxLayoutGap="5px">
                    <div class="text-secondary">
                      {{ "flows.fraudCosts" | translate }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start">
                      <div class="text-primary">
                        <svg width="45" height="15" viewBox="0 0 45 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="45" height="15" fill="#EEEEEE" />
                        </svg>
                      </div>
                    </div>
                    <div class="text-secondary">
                      <svg width="45" height="15" viewBox="0 0 45 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="45" height="15" fill="#EEEEEE" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="container-itens" fxFlex fxLayout="row" *ngIf="error">
                  <div class="item-separator" fxFlex fxFlex.xs="none" fxLayout="column" fxLayoutAlign="center stretch"
                    fxLayoutGap="5px">

                    <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" fxLayoutGap="15px">
                      <mat-icon class="fc-9">error</mat-icon>
                      <div class="text" fxFlex>
                        <span class="fs-12 fc-9"> Falha ao carregar os dados.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>

          <div class="mr-4" fxLayoutAlign="center stretch" fxLayoutGap="10px" fxShow fxHide.lt-md="true">
            <div class="tab-list" fxFlex fxFlexFill fxLayoutAlign="center stretch" fxLayoutGap="5px">
              <div class="tab active" fxLayoutAlign="center center">
                <button mat-icon-button (click)="changeName()" *ngIf="model.flow_version?.status == 0">
                  <mat-icon svgIcon="icon_gear"></mat-icon>
                </button>
                <div fxHide fxShow.xs="true">
                  {{ "flows.detail.results" | translate }}
                </div>
              </div>
              <div class="tab active" fxLayoutAlign="center center" *ngIf="model.selector_test_flow?.status == 1">
                <button mat-icon-button (click)="openCreateAb()">
                  <mat-icon svgIcon="icon_experiment"></mat-icon>
                </button>
                <div fxHide fxShow.xs="true">
                  {{ "flows.detail.abExperimen" | translate }}
                </div>
              </div>
            </div>

            <!-- <div class="icon-action" fxLayoutAlign="center center">
                <button mat-icon-button [matMenuTriggerFor]="moreActions">
                  <mat-icon class="ic-28">more_horiz</mat-icon>
                </button>
                <mat-menu class="flow-header-actions" #moreActions="matMenu" xPosition="before">
                  <button mat-menu-item>
                    <mat-icon svgIcon="icon_gear"></mat-icon>
                    <span>{{ 'flows.detail.configuration' | translate}}</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon svgIcon="icon_experiment"></mat-icon>
                    <span>{{ 'flows.detail.abExperiment' | translate}}</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon svgIcon="icon_copy"></mat-icon>
                    <span>{{ 'flows.detail.duplicate' | translate}}</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon>pause_circle_outline</mat-icon>
                    <span>{{ 'flows.detail.duplicate' | translate}}</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon>star_border</mat-icon>
                    <span>{{ 'flows.detail.turndefault' | translate}}</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon>attach_money</mat-icon>
                    <span>{{ 'flows.detail.transacations' | translate}}</span>
                  </button>
                </mat-menu>
              </div> -->
          </div>

          <div fxLayoutAlign="end center" fxLayoutGap="25px" fxLayoutGap.lt-lg="15px" fxLayoutGap.lt-md="0">
            <div class="action-publish" fxShow fxHide.lt-md="true">
              <!-- TODO: Remover comentário quando existir regra de Publicação Beta -->
              <!-- <span class="stamp">beta</span> -->
              <div>
                <button class="btn-publish h-medium" mat-flat-button color="primary" (click)="openValidate()"
                  *ngIf="model.selector_test_flow?.status != 1" [disabled]="!permission.publish  || onlyViewer">
                  <!-- <mat-icon aria-hidden="false" aria-label="publish"
                      >publish</mat-icon
                    > -->
                  <mat-icon aria-hidden="false" aria-label="validate" svgIcon="icon_validate"></mat-icon>
                  <span>{{ "flows.detail.validate.label" | translate }}</span>
                </button>
                <button class="btn-publish h-medium" mat-flat-button color="primary" (click)="openEdit()"
                  *ngIf="model.selector_test_flow?.status == 1">
                  <!-- <mat-icon aria-hidden="false" aria-label="publish"
                      >publish</mat-icon
                    > -->
                  <span>{{ "flows.detail.edit.label" | translate }}</span>
                </button>
              </div>
            </div>
            <div class="action-menu" (click)="flowsList()">
              <mat-icon class="action-icon" aria-hidden="false" aria-label="close" svgIcon="icon_close"></mat-icon>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="autosave" fxLayoutAlign="end center" fxLayoutGap="5px" fxShow fxHide.lt-md="true"
      *ngIf="model.selector_test_flow">
      <mat-icon
        *ngIf="!saving && (model.selector_test_flow?.status == 0  || model.selector_test_flow?.status == 4)">loop</mat-icon>
      <div *ngIf=" !saving">
        {{
        ( model.selector_test_flow?.status == 0 || model.selector_test_flow?.status == 4) ? ("flows.detail.draft"
        |
        translate) : ""
        }}
        {{
        model.flow_version?.last_update_username.toLowerCase() === "sys"
        ? "Tuna"
        : model.flow_version?.last_update_username
        }}
        -
        {{
        model.flow_version?.last_update_date_gmt
        | localizedDate : "dd/MM/YY HH:mm:ss"
        }}
      </div>

      <div *ngIf="saving">{{ "flows.detail.saving" | translate }}</div>
    </div>

    <div class="sidenav-container" fxFlex="100" fxFlexFill>
      <div class="sidenav-content" fxFlex="100" fxFlexFill fxLayout="column" *ngIf="model.ab != 'control'">
        <div class="flow-detail" cdkDropListGroup>
          <div class="timeline" fxFlex="100" fxFlexFill fxLayout="column">
            <!-- START -->
            <div class="item start" fxFlex="100" fxFlexFill fxLayoutGap="12px" fxLayoutAlign="center center">
              <div class="line" fxFlex fxFlexFill>
                <div class="icon" fxFlex="40px" fxFlex.xs="30px" fxLayoutAlign="center center">
                  <mat-icon inline="true">outlined_flag</mat-icon>
                </div>
              </div>

              <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="space-between center">
                <div class="start fc-3">
                  {{ "flows.detail.timeline.start" | translate }}
                </div>
                <div>
                  <button class="expand-flow" mat-mini-fab disableRipple color="white" (click)="collapseAllToggle()"
                    fxShow fxHide.lt-md="true" matTooltip="{{
                  expandedStepState
                    ? ('flows.detail.collapseall' | translate)
                    : ('flows.detail.expandall' | translate)
                }}">
                    <mat-icon *ngIf="expandedStepState" svgIcon="icon_expand-less" class="icon-expand-flow"></mat-icon>
                    <mat-icon *ngIf="!expandedStepState" svgIcon="icon_expand-more" class="icon-expand-flow"></mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- FILTERS -->
            <div class="item" fxFlex="100" fxFlexFill.gt-sm fxFlex.lt-md="auto" fxLayoutAlign.lt-md="start start">
              <div class="line" fxFlex="60px" fxFlex.xs="45px">
                <div class="icon" #iconFlow [style.top]="iconFlowTop" fxFlex="40px" fxFlex.xs="30px"
                  fxLayoutAlign="center center">
                  <mat-icon svgIcon="icon_filter"></mat-icon>
                </div>
              </div>
              <div fxFlex="100" fxLayout="column">
                <div class="content" fxFlex="100" fxLayout="column" fxFlexFill.gt-sm fxLayoutAlign="start stretch"
                  *ngFor="
                let filter of model.flow_version.filters;
                let index = index;
                let last = last
              ">
                  <app-flow-filter2 *ngIf="loadedFlow" [form]="form" fxFlex="100" fxLayout="column"
                    [onlyViewer]="onlyViewer" [index]="index" (removeFilter)="removeFilter(filter)" fxFlexFill.gt-sm
                    [filter]="filter" [operations]="model.operations" [is_default]="model.flow_version.is_default"
                    [terms]="model.terms">
                  </app-flow-filter2>
                  <div *ngIf="!last" class="mt-2 mb-2 ml-4">
                    <div class="fc-6 fs-12">
                      {{ "flows.detail.fields.or" | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item add-new" fxFlex="100" fxFlexFill.gt-sm fxHide.lt-sm="true" fxFlex.lt-md="auto">
              <div fxFlex="60px" fxFlex.xs="45px"></div>
              <div fxLayout="row" fxFlex="100" *ngIf="!onlyViewer && !model.flow_version.is_default">
                <a fxLayoutAlign="start center" class="fw-m" fxFlex="100" (click)="addFilter()">
                  {{ "flows.detail.addNew" | translate }}
                </a>
              </div>
            </div>
            <div class="item empty" id="doneList" #doneList="cdkDropList" cdkDropList fxFlex="100" fxFlexFill
              fxLayout="column" [cdkDropListData]="model.flow_version.flow_orders" (cdkDropListDropped)="drop($event)">
              <!-- AS EMPTY -->
              <div class="item" fxFlex="100" fxFlexFill.gt-sm fxFlex.lt-md="auto" fxLayoutAlign.lt-md="start center"
                *ngIf="model.flow_version.flow.flow_type_id == 0 &&
              !(model.flow_version.authorization_scheme_id > 0) &&
              model.selector_test_flow.status != 1
            ">
                <div class="line" fxFlex="60px" fxFlex.xs="45px">
                  <div class="icon" #iconFlow [style.top]="iconFlowTop" fxFlex="40px" fxFlex.xs="30px"
                    fxLayoutAlign="center center">
                    <mat-icon inline="true">payment </mat-icon>
                  </div>
                </div>
                <div class="content collapsible" fxFlex="100" fxFlexFill.gt-sm fxLayoutAlign="start start">
                  <div class="item-detail" fxFlex="100" fxFlexFill>
                    <mat-card appearance="outlined" class="item-detail" fxFlex="100">
                      <mat-card-content>
                        <!-- TODO: Depende de atualização dos serviços -->
                        <!-- <div class="close-empty" fxLayout="row" fxLayoutAlign="end stretch">
                      <button mat-icon-button>
                        <mat-icon class="icon-close ic-svg-9">close</mat-icon>
                      </button>
                    </div> -->
                        <div class="detail mt-2 mb-2" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="16px">
                          <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
                            <mat-icon>payment</mat-icon>
                            <div class="fs-18 font-color">
                              {{
                              "flows.detail.emptyState.authScheme.title"
                              | translate
                              }}
                            </div>
                          </div>
                          <div fxLayout="column" fxLayoutGap="16px">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                              <div class="number fs-16 fc-6" fxLayoutAlign="center center">
                                1
                              </div>
                              <div class="text fc-6 font-color">
                                {{
                                "flows.detail.emptyState.authScheme.list.one"
                                | translate
                                }}
                              </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                              <div class="number fs-16 fc-6" fxLayoutAlign="center center">
                                2
                              </div>
                              <div class="text fc-6 font-color">
                                {{
                                "flows.detail.emptyState.authScheme.list.two"
                                | translate
                                }}
                              </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                              <div class="number fs-16 fc-6" fxLayoutAlign="center center">
                                3
                              </div>
                              <div class="text fc-6 font-color">
                                {{
                                "flows.detail.emptyState.authScheme.list.three"
                                | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                </div>
              </div>

              <!-- ACTIONS EMPTY -->
              <div class="item" fxFlex="100" fxFlexFill.gt-sm fxFlex.lt-md="auto" fxLayoutAlign.lt-md="start center"
                fxFlexFill *ngIf="
              !model.flow_version.flow_orders_actions_exists && model.selector_test_flow?.status == 0
            ">
                <div class="line" fxFlex="60px" fxFlex.xs="45px">
                  <div class="icon" #iconFlow [style.top]="iconFlowTop" fxFlex="40px" fxFlex.xs="30px"
                    fxLayoutAlign="center center">
                    <mat-icon inline="true">security </mat-icon>
                  </div>
                </div>
                <div class="content colla psible" fxFlex="100" fxFlexFill.gt-sm fxLayoutAlign="start start">
                  <div class="item-detail" fxFlex="100" fxFlexFill>
                    <mat-card appearance="outlined" class="item-detail" fxFlex="100">
                      <mat-card-content>
                        <!-- TODO: Depende de atualização dos serviços -->
                        <!-- <div class="close-empty" fxLayout="row" fxLayoutAlign="end stretch">
                      <button mat-icon-button>
                        <mat-icon class="icon-close ic-svg-9">close</mat-icon>
                      </button>
                    </div> -->
                        <div class="detail mt-2 mb-2" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="16px">
                          <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
                            <mat-icon>security</mat-icon>
                            <div class="fs-18 font-color">
                              {{
                              "flows.detail.emptyState.action.title"
                              | translate
                              }}
                            </div>
                          </div>
                          <div fxLayout="column" fxLayoutGap="16px">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                              <div class="number fs-16 fc-6" fxLayoutAlign="center center">
                                1
                              </div>
                              <div class="text fc-6">
                                {{
                                "flows.detail.emptyState.action.list.one"
                                | translate
                                }}
                              </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                              <div class="number fs-16 fc-6" fxLayoutAlign="center center">
                                2
                              </div>
                              <div class="text fc-6">
                                {{
                                "flows.detail.emptyState.action.list.two"
                                | translate
                                }}
                              </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                              <div class="number fs-16 fc-6" fxLayoutAlign="center center">
                                3
                              </div>
                              <div class="text fc-6">
                                {{
                                "flows.detail.emptyState.action.list.three"
                                | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                </div>
              </div>

              <div class="item" fxLayoutAlign="start center" fxFlex="100" fxLayout="row" [ngClass]="{
              test: model.flow_version.changed
                ? model.flow_version.changed.authorization_scheme_changed
                : false,
              last: flow_order.type == 'capture' ? true : false
            }" *ngFor="
              let flow_order of model.flow_version.flow_orders;
              let first = first
            " cdkDragLockAxis="y" cdkDrag [cdkDragDisabled]="
              flow_order.type == 'manualanalysis' ||
              onlyViewer ||
              flow_order.type == 'capture'
            ">
                <!-- AS OBJECT  -->
                <div fxFlexFill *ngIf="
                flow_order.type == 'authorize' &&
                model.flow_version.authorization_scheme
              ">
                  <div class="item" *cdkDragPlaceholder>
                    <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                    <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                  </div>
                  <div class="line" fxFlex="60px" fxFlex.xs="45px">
                    <div class="icon" #iconFlow [style.top]="iconFlowTop" fxFlex="40px" fxFlex.xs="30px"
                      fxLayoutAlign="center center">
                      <mat-icon inline="true">payment </mat-icon>
                    </div>
                  </div>
                  <div class="content collapsible" fxFlex="100" fxFlexFill.gt-sm fxLayoutAlign="start start">
                    <app-flow-autorization-scheme [onlyViewer]="onlyViewer" fxFlex="100" (removeAS)="removeAS()"
                      [authorization_scheme]="model.flow_version.authorization_scheme"
                      [expandedStepState]="expandedStepState">
                    </app-flow-autorization-scheme>
                  </div>
                </div>

                <!-- ACTIONS OBJECTS -->
                <div fxFlexFill *ngIf="
                flow_order.type == 'antifraud' ||
                flow_order.type == 'action' ||
                flow_order.type == 'riskanalytics' ||
                flow_order.type == 'manualanalysis'  ||
                flow_order.type == 'checkenrollment'
              ">
                  <div class="item" *cdkDragPlaceholder>
                    <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                    <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                  </div>
                  <div class="line" fxFlex="60px" fxFlex.xs="45px">
                    <div class="icon" #iconFlow [style.top]="iconFlowTop" fxFlex="40px" fxFlex.xs="30px"
                      fxLayoutAlign="center center">
                      <mat-icon *ngIf="
                      flow_order.type == 'antifraud' ||
                      flow_order.type == 'riskanalytics' ||
                      flow_order.type == 'checkenrollment'
                    " inline="true">security</mat-icon>
                      <mat-icon *ngIf="flow_order.type == 'action' " inline="true">directions_run</mat-icon>
                      <mat-icon *ngIf="flow_order.type == 'manualanalysis'" inline="true">verified_user
                      </mat-icon>
                    </div>
                  </div>

                  @if(flow_order.type != 'zeroauth'){
                  <div class="content collapsible" fxFlex="100" fxFlexFill.gt-sm fxLayoutAlign="start start">
                    <app-flow-action *ngIf="loadedFlow" [form]="form" fxFlex="100" [onlyViewer]="onlyViewer"
                      fxFlexFill.gt-sm [flow]="model.flow_version" [flow_order]="flow_order"
                      [operations]="model.operations" [filter_antifrauds]="model.filter_antifrauds"
                      [filter_3ds]="model.filter_3ds" (changeInput)="changeInput($event)" [terms]="model.terms"
                      (removeAction)="removeAction($event, flow_order)" (addActionManual)="addActionManual($event)"
                      [expandedStepState]="expandedStepState" [isContainsServiceTuna]="model.isContainsServiceTuna">
                    </app-flow-action>
                  </div>
                  }

                  @if(flow_order.type == 'zeroauth'){
                  <div class="content collapsible" fxFlex="100" fxFlexFill.gt-sm fxLayoutAlign="start start">
                    <app-flow-action-zero-auth *ngIf="loadedFlow" [form]="form" fxFlex="100" [onlyViewer]="onlyViewer"
                      fxFlexFill.gt-sm [flow]="model.flow_version" [flow_order]="flow_order"
                      [operations]="model.operations" (changeInput)="changeInput($event)" [terms]="model.terms"
                      [expandedStepState]="expandedStepState">
                    </app-flow-action-zero-auth>
                  </div>
                  }
                </div>


                <div fxFlexFill *ngIf="
                flow_order.type == 'alternateauthorize'
              ">
                  <div class="item" *cdkDragPlaceholder>
                    <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                    <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                  </div>
                  <div class="line" fxFlex="60px" fxFlex.xs="45px">
                    <div class="icon" #iconFlow [style.top]="iconFlowTop" fxFlex="40px" fxFlex.xs="30px"
                      fxLayoutAlign="center center">
                      <mat-icon inline="true">payment </mat-icon>
                    </div>
                  </div>

                  <div class="content collapsible" fxFlex="100" fxFlexFill.gt-sm fxLayoutAlign="start start">
                    <app-flow-autorization-scheme-alternative [onlyViewer]="onlyViewer" fxFlex="100"
                      (removeASAlternative)="removeASAlternative()"
                      [authorization_scheme]="flow_order.actions[0]?.action.authorization_scheme"
                      [expandedStepState]="expandedStepState">
                    </app-flow-autorization-scheme-alternative>
                  </div>
                </div>

                <div fxFlexFill *ngIf="
                flow_order.type == 'zeroauth'
              ">
                  <div class="item" *cdkDragPlaceholder>
                    <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                    <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                  </div>
                  <div class="line" fxFlex="60px" fxFlex.xs="45px">
                    <div class="icon" #iconFlow [style.top]="iconFlowTop" fxFlex="40px" fxFlex.xs="30px"
                      fxLayoutAlign="center center">
                      <mat-icon inline="true">payment </mat-icon>
                    </div>
                  </div>

                  <div class="content collapsible" fxFlex="100" fxFlexFill.gt-sm fxLayoutAlign="start start">
                    <app-flow-autorization-scheme-zero-auth [onlyViewer]="onlyViewer" fxFlex="100"
                      (removeASZeroAuth)="removeASZeroAuth()"
                      [authorization_scheme]="flow_order.actions[0]?.action.authorization_scheme"
                      [expandedStepState]="expandedStepState">
                    </app-flow-autorization-scheme-zero-auth>
                  </div>
                </div>

              </div>

              <!-- CAPTURE -->

              <div class="item" fxLayoutAlign="start center" fxFlex="100" fxLayout="row" class="last" *ngFor="
              let flow_order of model.flow_version.flow_orders;
              let first = first
            ">
                @if (model.flow_version.flow.flow_type_id == 0) {
                <div *ngIf="
                flow_order.type == 'capture' ||
                flow_order.type == 'waitoncapture' ||
                flow_order.type == 'cancel'
              " class="item end" fxFlex="100" fxFlexFill.gt-sm fxFlex.lt-md="auto" fxLayoutAlign.lt-md="start center">
                  <div class="item end" *cdkDragPlaceholder>
                    <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                    <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                  </div>

                  <div class="content end" fxFlex="none" fxLayoutGap="10px">
                    <mat-card appearance="outlined" fxLayout="row" fxFlex="none" fxLayoutGap="10px"
                      fxLayoutAlign="start center" [ngClass]="{
                        disabled: onlyViewer
                      }" class="flow-float-menu" [style.position]="'relative'" [matMenuTriggerFor]="endFlowMenu">
                      <div class="icon"
                        [ngClass]="{ success: menuEnd.toLowerCase() == 'capture', alert: menuEnd.toLowerCase() == 'waitoncapture', error: menuEnd.toLowerCase() == 'cancel' }"
                        fxLayout="row" fxLayoutAlign="center center">
                        @if(menuEnd.toLowerCase() == 'capture') {
                        <mat-icon inline="true">check</mat-icon>
                        }
                        @if(menuEnd.toLowerCase() == 'waitoncapture') {
                        <mat-icon svgIcon="icon_simple-alert"></mat-icon>
                        }
                        @if(menuEnd.toLowerCase() == 'cancel') {
                        <mat-icon inline="true">close</mat-icon>
                        }
                      </div>
                      <div class="fc-3 fs-12 fw-b uppercase">
                        {{ "flows.detail.timeline.end." + menuEnd | translate }}
                      </div>
                      <mat-icon class="icon-expand" class="c-pointer" *ngIf="!onlyViewer">
                        keyboard_arrow_down
                      </mat-icon>
                    </mat-card>
                    <mat-menu class="flow-float-menu" #endFlowMenu="matMenu">
                      <div mat-menu-item fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center"
                        (click)="menu('capture')">
                        <div class="icon success" fxLayout="row" fxLayoutAlign="center center">
                          <mat-icon inline="true">check</mat-icon>
                        </div>
                        <div class="fc-3 fs-12 fw-b uppercase">
                          {{ "flows.detail.timeline.end.capture" | translate }}
                        </div>
                      </div>
                      <div mat-menu-item fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center"
                        (click)="menu('waitoncapture')">
                        <div class="icon alert" fxLayout="row" fxLayoutAlign="center center">
                          <mat-icon svgIcon="icon_simple-alert"></mat-icon>
                        </div>
                        <div class="fc-3 fs-12 fw-b uppercase">
                          {{
                          "flows.detail.timeline.end.waitoncapture"
                          | translate
                          }}
                        </div>
                      </div>
                      <div mat-menu-item fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center"
                        (click)="menu('cancel')">
                        <div class="icon error" fxLayout="row" fxLayoutAlign="center center">
                          <mat-icon inline="true">close</mat-icon>
                        </div>
                        <div class="fc-3 fs-12 fw-b uppercase">
                          {{ "flows.detail.timeline.end.cancel" | translate }}
                        </div>
                      </div>
                    </mat-menu>
                  </div>
                </div>
                }
                @if (model.flow_version.flow.flow_type_id == 1) {
                <div *ngIf="
                flow_order.type == 'approve' ||
                flow_order.type == 'denied' ||
                flow_order.type == 'waitantifraud'
              " class="item end" fxFlex="100" fxFlexFill.gt-sm fxFlex.lt-md="auto" fxLayoutAlign.lt-md="start center">
                  <div class="item end" *cdkDragPlaceholder>
                    <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                    <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                  </div>

                  <div class="content end" fxFlex="none" fxLayoutGap="10px">
                    <mat-card appearance="outlined" fxLayout="row" fxFlex="none" fxLayoutGap="10px"
                      fxLayoutAlign="start center" [ngClass]="{
                      disabled: onlyViewer
                    }" class="flow-float-menu" [style.position]="'relative'"
                      [matMenuTriggerFor]="endFlowMenuAntifraud">
                      <div class="icon"
                        [ngClass]="{ success: menuEnd.toLowerCase() == 'approve', alert:menuEnd.toLowerCase() == 'waitantifraud', error:menuEnd.toLowerCase() == 'denied' }"
                        fxLayout="row" fxLayoutAlign="center center">
                        @if(menuEnd.toLowerCase() == 'approve') {
                        <mat-icon inline="true">check</mat-icon>
                        }
                        @if(menuEnd.toLowerCase() == 'waitantifraud') {
                        <mat-icon svgIcon="icon_simple-alert"></mat-icon>
                        }
                        @if(menuEnd.toLowerCase() == 'denied') {
                        <mat-icon inline="true">close</mat-icon>
                        }
                      </div>
                      <div class="fc-3 fs-12 fw-b uppercase">
                        {{ "flows.detail.timeline.end." + menuEnd | translate }}
                      </div>
                      <mat-icon class="icon-expand" class="c-pointer" *ngIf="!onlyViewer">
                        keyboard_arrow_down
                      </mat-icon>
                    </mat-card>
                    <mat-menu class="flow-float-menu" #endFlowMenuAntifraud="matMenu">
                      <div mat-menu-item fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center"
                        (click)="menu('approve')">
                        <div class="icon success" fxLayout="row" fxLayoutAlign="center center">
                          <mat-icon inline="true">check</mat-icon>
                        </div>
                        <div class="fc-3 fs-12 fw-b uppercase">
                          {{ "flows.detail.timeline.end.approve" | translate }}
                        </div>
                      </div>
                      <div mat-menu-item fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center"
                        (click)="menu('waitantifraud')">
                        <div class="icon alert" fxLayout="row" fxLayoutAlign="center center">
                          <mat-icon svgIcon="icon_simple-alert"></mat-icon>
                        </div>
                        <div class="fc-3 fs-12 fw-b uppercase">
                          {{
                          "flows.detail.timeline.end.waitantifraud"
                          | translate
                          }}
                        </div>
                      </div>
                      <div mat-menu-item fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center"
                        (click)="menu('denied')">
                        <div class="icon error" fxLayout="row" fxLayoutAlign="center center">
                          <mat-icon inline="true">close</mat-icon>
                        </div>
                        <div class="fc-3 fs-12 fw-b uppercase">
                          {{ "flows.detail.timeline.end.denied" | translate }}
                        </div>
                      </div>
                    </mat-menu>
                  </div>
                </div>
                }
              </div>


            </div>
          </div>
        </div>

        <!-- CHANGED FLOWS -->
        <!-- <div class="flow-detail flow-deleted" *ngIf="model.flow_version.status == 1 && model.flow_version.changed">
          <div class="timeline" fxFlex="100" fxFlexFill fxLayout="column"
            *ngIf="model.flow_version.changed.deleted_flow_orders.length > 0">
            <!-- Deleted itens -->
        <!-- <div class="item" fxFlex="100" fxFlexFill>
              <div fxFlex="60px" fxFlex.xs="40px" fxFlexFill></div>
              <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center">
                <div class="deleted-itens" fxFlex="100" fxFlexFill fxLayoutAlign="center center">
                  <div class="label">
                    {{ "flows.detail.testDetail.itensRemoved" | translate }}
                  </div>
                </div>
              </div>
            </div> -->

        <!-- <div class="item" fxFlex="100" fxFlexFill fxLayoutAlign.lt-md="start center"
              *ngFor="let flow_order of model.flow_version.changed.deleted_flow_orders" [ngClass]="{ delete: true }">
              <div class="line" fxFlex="60px" fxFlex.xs="45px" *ngIf="
              flow_order.type == 'action' || flow_order.type == 'antifraud'  || flow_order.type == 'checkenrollment'  || flow_order.type == 'checkenrollment'
            ">
                <div class="icon" #iconFlow [style.top]="iconFlowTop" fxFlex="40px" fxFlex.xs="30px"
                  fxLayoutAlign="center center">
                  <mat-icon *ngIf="flow_order.type == 'antifraud'|| flow_order.type == 'checkenrollment'"
                    inline="true">security</mat-icon>
                  <mat-icon *ngIf="flow_order.type == 'action'" inline="true">directions_run</mat-icon>
                  <mat-icon *ngIf="flow_order.type == 'manualanalysis'" inline="true">verified_user
                  </mat-icon>
                  <mat-icon *ngIf="flow_order.type == 'authorize'" inline="true">payment
                  </mat-icon>
                </div>
              </div>
              <!-- <div class="content collapsible" fxFlex="100" fxFlexFill.gt-sm fxLayoutAlign="start center"
        *ngIf="flow_order.type == 'Authorize'">
        <app-autorization-scheme fxFlex="100" fxFlexFill.gt-sm [flow_order]="flow_order"
          [authorization_scheme]="model.flow.authorization_scheme" [expandedStepState]="expandedStepState">
        </app-autorization-scheme>
      </div> -->
        <!-- <div class="content collapsible" fxFlex="100" fxFlexFill.gt-sm fxLayoutAlign="start start" *ngIf="
              flow_order.type == 'action' || flow_order.type == 'antifraud'  || flow_order.type == 'checkenrollment'
            ">
                <app-flow-action fxFlex="100" fxFlexFill.gt-sm [flow_order]="flow_order"
                  [expandedStepState]="expandedStepState">
                </app-flow-action>
              </div>
            </div> -->
        <!-- </div> -->
        <!-- </div>  -->
      </div>

      <!-- TEST AB - CONTROL -->
      <div class="sidenav-content" fxFlex="100" fxFlexFill fxLayout="column" *ngIf="model.ab == 'control'">
        <div class="test-result">
          <mat-card appearance="outlined">
            <div fxLayout="row" class="flows-header">
              <div class="calendar" (click)="openPeriod()" fxLayoutAlign="end center">
                <mat-icon class="mr-2" aria-hidden="false" aria-label="Calendar">calendar_today</mat-icon>
                <span>{{
                  (model.period.start
                  ? model.period.start
                  : model.last_update
                  ) | localizedDate
                  }}
                </span>
                <span> &nbsp; - &nbsp;</span><span>{{ model.period.end | localizedDate }} </span>
                <div class="mat-select-arrow-wrapper ml-3">
                  <div class="mat-select-arrow mt-1"></div>
                </div>
              </div>
            </div>
          </mat-card>

          <div class="test-chart">
            <app-flow-test [selector_test]="model.selector_test" [flow_version]="model.flow_version"></app-flow-test>
          </div>
          <!-- <app-flow-chart-test
        [chart]="chart$ | async"
        [selector_test_id]="model.selector_test_id"
      ></app-flow-chart-test> -->
        </div>
      </div>

      <!-- SIDENAV - LATERAL -->
      <div class="sidenav" fxFlex="420px" fxFlex.lt-lg="380px" fxFlex.md="350px" fxShow fxHide.lt-md fxFlexFill
        *ngIf="(model.ab == 'normal' || model.ab == 'B') && (model.selector_test_flow?.status == 0)" fxLayout="column">
        <div class="flow-sidebar">
          <div class="title">Templates</div>
          <div class="option" *ngIf="model.flow_version.flow.flow_type_id == 0">
            <mat-card appearance="outlined">
              <mat-card-content>
                <mat-expansion-panel hideToggle expanded>
                  <mat-expansion-panel-header fxLayoutAlign="center center">
                    <mat-panel-title fxLayoutAlign="start center">
                      <mat-icon class="icon-option ic-svg-3">payment</mat-icon>
                      <div class="title ml-2">
                        {{ "flows.detail.autorizationscheme" | translate }}
                      </div>
                    </mat-panel-title>
                    <button class="btn-expand" mat-icon-button>
                      <mat-icon class="icon-expand">keyboard_arrow_down</mat-icon>
                    </button>
                  </mat-expansion-panel-header>
                  <div class="detail" fxLayout="column">
                    <div class="pb-3" cdkDropList #todoList="cdkDropList" [cdkDropListConnectedTo]="['doneList']"
                      [cdkDropListData]="model.authorization_schemes" cdkDropListSortingDisabled>
                      <div class="item-sidebar auth-scheme" [ngClass]="!onlyViewer && 'editable'" fxLayout="row"
                        fxLayoutAlign="start center" fxLayoutGap="8px" *ngFor="let item of model.authorization_schemes"
                        cdkDrag [cdkDragDisabled]="item.default || onlyViewer" [ngClass]="{
                      dropped: item.dropped,
                      editable: !onlyViewer
                    }" (click)="
                      !onlyViewer
                        ? openAuthorization(item)
                        : $event.stopPropagation()
                    ">
                        <mat-icon class="drag-item" *ngIf="!item.dropped && !onlyViewer" fxShow fxHide.lt-md="true">
                          drag_indicator
                        </mat-icon>
                        <mat-icon class="icon-check" *ngIf="item.dropped">check_circle</mat-icon>
                        <div class="item" *cdkDragPlaceholder>
                          <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                          <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                        </div>
                        {{ item.name }}
                        <div *ngIf="item.name?.includes('Zero Auth')" class="ml-3">
                          <div class="tag ellipsis pending">
                            {{ 'flows.detail.autorization.zero_auth' | translate }}
                          </div>
                        </div>
                        <div class="icon alert" fxLayout="row" fxLayoutAlign="center center"></div>
                      </div>
                    </div>

                    <div fxLayout="row" fxFlex="100" *ngIf="!onlyViewer">
                      <a fxLayoutAlign="center center" class="fw-m" fxFlex="100" (click)="openAuthorizationAdd()">
                        {{ "flows.detail.addNew" | translate }}
                      </a>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="option">
            <mat-card appearance="outlined">
              <mat-card-content>
                <mat-expansion-panel hideToggle expanded>
                  <mat-expansion-panel-header fxLayoutAlign="center center">
                    <mat-panel-title fxLayoutAlign="start center">
                      <mat-icon class="icon-option ic-svg-3">security</mat-icon>
                      <div class="title ml-2">
                        {{ "flows.detail.fraud" | translate }}
                      </div>
                    </mat-panel-title>
                    <button class="btn-expand" mat-icon-button>
                      <mat-icon class="icon-expand">keyboard_arrow_down</mat-icon>
                    </button>
                  </mat-expansion-panel-header>
                  <div class="detail" fxLayout="column">
                    <div class="pb-3" cdkDropList [cdkDropListData]="model.services"
                      [cdkDropListConnectedTo]="['doneList']">
                      <div class="item-sidebar fraud" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
                        *ngFor="let service of model.services" cdkDrag cdkDropListSortingDisabled
                        [cdkDragDisabled]="onlyViewer" [ngClass]="{
                      dropped: service.dropped,
                      editable: !onlyViewer
                    }">
                        <mat-icon class="drag-item" *ngIf="
                        !service.dropped &&
                        !onlyViewer &&
                        !model.isContainsServiceTuna
                      " fxShow fxHide.lt-md="true">
                          drag_indicator
                        </mat-icon>
                        <mat-icon class="icon-check" *ngIf="service.dropped">check_circle</mat-icon>

                        <div class="item" *cdkDragPlaceholder>
                          <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                          <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                        </div>
                        <app-flow-services [fraud_verification]="service">
                        </app-flow-services>
                      </div>
                    </div>
                    <div fxLayout="row" fxFlex="100" *ngIf="!onlyViewer">
                      <a fxLayoutAlign="center center" class="fw-m" fxFlex="100" (click)="redirectServices()">
                        {{ "flows.detail.addNew" | translate }}
                      </a>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-card-content>
            </mat-card>

          </div>
          <div class="option" *ngIf="model.threeds.length > 0">
            <mat-card appearance="outlined">
              <mat-card-content>
                <mat-expansion-panel hideToggle expanded>
                  <mat-expansion-panel-header fxLayoutAlign="center center">
                    <mat-panel-title fxLayoutAlign="start center">
                      <mat-icon class="icon-option ic-svg-3">security</mat-icon>
                      <div class="title ml-2">
                        {{ "flows.detail.3ds" | translate }}
                      </div>
                    </mat-panel-title>
                    <button class="btn-expand" mat-icon-button>
                      <mat-icon class="icon-expand">keyboard_arrow_down</mat-icon>
                    </button>
                  </mat-expansion-panel-header>
                  <div class="detail" fxLayout="column">
                    <div class="pb-3" cdkDropList [cdkDropListData]="model.threeds"
                      [cdkDropListConnectedTo]="['doneList']">
                      <div class="item-sidebar fraud" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
                        *ngFor="let service_3ds of model.threeds" cdkDrag cdkDropListSortingDisabled
                        [cdkDragDisabled]="onlyViewer" [ngClass]="{
                      dropped: service_3ds.dropped,
                      editable: !onlyViewer
                    }">
                        <mat-icon class="drag-item" *ngIf="
                        !service_3ds.dropped &&
                        !onlyViewer &&
                        !model.isContainsServiceTuna
                      " fxShow fxHide.lt-md="true">
                          drag_indicator
                        </mat-icon>
                        <mat-icon class="icon-check" *ngIf="service_3ds.dropped">check_circle</mat-icon>

                        <div class="item" *cdkDragPlaceholder>
                          <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                          <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                        </div>
                        <app-flow-services-3ds [service_3ds]="service_3ds">
                        </app-flow-services-3ds>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="option">
            <mat-card appearance="outlined">
              <mat-card-content>
                <mat-expansion-panel hideToggle expanded>
                  <mat-expansion-panel-header fxLayoutAlign="center center">
                    <mat-panel-title fxLayoutAlign="start center">
                      <mat-icon class="icon-option ic-svg-3" svgIcon="icon_custom_services"></mat-icon>
                      <div class="title ml-2">
                        {{ "flows.detail.custom_services" | translate }}
                      </div>
                    </mat-panel-title>
                    <button class="btn-expand" mat-icon-button>
                      <mat-icon class="icon-expand">keyboard_arrow_down</mat-icon>
                    </button>
                  </mat-expansion-panel-header>
                  <div class="detail" fxLayout="column">
                    <div class="pb-3" cdkDropList [cdkDropListData]="model.custom_services"
                      [cdkDropListConnectedTo]="['doneList']">
                      <div class="item-sidebar fraud" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
                        *ngFor="let service of model.custom_services" cdkDrag cdkDropListSortingDisabled
                        [cdkDragDisabled]="onlyViewer">
                        <mat-icon class="drag-item" *ngIf="!service.dropped && !onlyViewer" fxShow fxHide.lt-md="true">
                          drag_indicator
                        </mat-icon>
                        <mat-icon class="icon-check" *ngIf="service.dropped">check_circle</mat-icon>
                        <div class="item" *cdkDragPlaceholder>
                          <div class="line" fxFlex="60px" fxFlex.xs="45px" fxFlexFill></div>
                          <div class="content" fxFlex="100" fxFlexFill fxLayoutAlign="start center"></div>
                        </div>
                        <app-flow-custom-services [custom_service]="service">
                        </app-flow-custom-services>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>